import { EventEmitter, Injectable } from '@angular/core';
import $ from 'jquery';
import { ElasticSearchData } from '../models/elasticSearchData';
@Injectable({
  providedIn: 'root'
})
export class ModalService {

  data$ = new EventEmitter<any>();

  constructor() { }

  showModalGenerico(err?: { err: boolean; } | undefined, parameter?: undefined){
    err && console.error("Error: ", err)
    if(parameter){
      if(document.getElementById('modalGenerico')){
        $("#modalGenerico h1").text('Algo inesperado ocurrió')
        $("#modalGenerico p").text('Tuvimos un inconveniente para terminar el proceso de validación. Intenta nuevamente')
        $("#modalGenerico button").text('Intentar de nuevo')
        //$("#modalGenerico i").removeAttr('class')
        //$("#modalGenerico i").addClass('fa fa-exclamation-triangle')
         // @ts-ignore
        document.getElementById('modalGenerico').classList.remove('d-none')
         // @ts-ignore
        document.getElementById('modalGenerico').classList.add('d-flex')
      }
    }else{
      if(document.getElementById('modalGenerico')){
        $("#modalGenerico h1").text('Algo inesperado ocurrió')
        $("#modalGenerico p").text('Tuvimos un inconveniente para terminar el proceso de validación. Intenta nuevamente')
        $("#modalGenerico button").text('Intentar de nuevo')
        //$("#modalGenerico i").removeAttr('class')
        //$("#modalGenerico i").addClass('fa fa-exclamation-triangle')
         // @ts-ignore
        document.getElementById('modalGenerico').classList.remove('d-none')
         // @ts-ignore
        document.getElementById('modalGenerico').classList.add('d-flex')
      }
    }
    
  }

  showModalInfo(data: string){
    if(document.getElementById('modalInfo')){
      this.updateData(data)
       // @ts-ignore
      document.getElementById('modalInfo').classList.remove('d-none')
       // @ts-ignore
      document.getElementById('modalInfo').classList.add('d-flex')
    }
  }

  hideModalInfo(){
    if(document.getElementById('modalInfo')){
       // @ts-ignore
      document.getElementById('modalInfo').classList.remove('d-flex')
       // @ts-ignore
      document.getElementById('modalInfo').classList.add('d-none')
    }
  }

  updateData(data: any){
    // console.log("updateData", data)
    this.data$.emit(data);
  }

  clearData(){
    this.data$.emit(null)
  }

  showModalError(title: string, text: string, ico?: string){
    if(document.getElementById('modalGenerico')){
      $("#modalGenerico h1").text(title)
      $("#modalGenerico p").text(text)
      $("#modalGenerico button").text('Entendido')
      if(ico){
        $("#modalGenerico i").removeAttr('class')
        $("#modalGenerico i").addClass(`fa fa-${ico}`)
      }
       // @ts-ignore
      document.getElementById('modalGenerico').classList.remove('d-none')
       // @ts-ignore
      document.getElementById('modalGenerico').classList.add('d-flex')
    }
  }

  hideModalGenerico(){
    if(document.getElementById('modalGenerico')){
       // @ts-ignore
      document.getElementById('modalGenerico').classList.remove('d-flex')
       // @ts-ignore
      document.getElementById('modalGenerico').classList.add('d-none')
    }
  }

  showLoading(){
    if(document.getElementById('loading')){
       // @ts-ignore
      document.getElementById('loading').classList.remove('d-none')
       // @ts-ignore
      document.getElementById('loading').classList.add('d-block')
    }
  }

  hideLoading(){
    if(document.getElementById('loading')){
       // @ts-ignore
      document.getElementById('loading').classList.remove('d-block')
       // @ts-ignore
      document.getElementById('loading').classList.add('d-none')
    }
  }

}
